import React, { useState } from 'react';
import { bool, func, object, string } from 'prop-types';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as DeviceActions from '../../actions/deviceActions';

import classes from './DevicesTableRowMenu.module.css';

const DevicesTableRowMenu = ({
    agentId,
    device,
    companyInfo,
    hidden,
    history,
    location,
    profileId,
    setDevice,
    onDeleteModal,
    onImportModal,
    onManageModal,
    reloadDeviceObjects
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
        setDevice(device);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleImportCSV() {
        setDevice(device);
        onImportModal(true);
        handleClose();
    }

    function handleManageDevice() {
        setDevice(device);
        onManageModal(true);
        handleClose();
    }

    function handleToggleDeleteModal() {
        onDeleteModal(device);
        handleClose();
    }

    function handleReloadDeviceObjects() {
        reloadDeviceObjects(device.id);
        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                {
                    device.loadFailed &&
                    <MenuItem onClick={handleReloadDeviceObjects}>
                        <img
                            alt=""
                            className={classes.contextIcon}
                            src="/assets/images/restartAppIcon.svg"
                        />
                        Reload Device Objects
                    </MenuItem>
                }
                <MenuItem onClick={handleManageDevice}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/SettingsFlat.svg"
                    />
                    Manage Device
                </MenuItem>
                <MenuItem onClick={handleImportCSV}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/actionBarItem-add.svg"
                    />
                    Import from CSV
                </MenuItem>
                <MenuItem onClick={handleToggleDeleteModal}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Delete Device
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

DevicesTableRowMenu.defaultProps = {
    hidden:    false,
    setDevice: () => {}
};

DevicesTableRowMenu.propTypes = {
    agentId:     string.isRequired,
    device:      object,
    companyInfo: object,
    hidden:      bool,
    history:     object,
    location:    object,
    profileId:   string,
    setDevice:   func
};

const mapDispatchToProps = {
    ...DeviceActions
};

export default withRouter(
    connect(null, mapDispatchToProps)(DevicesTableRowMenu)
);
